// extracted by mini-css-extract-plugin
export var container = "internationalTabsContent-module--container--29d3c";
export var subcontainer = "internationalTabsContent-module--subcontainer--c95a4";